<template>
    <div>
      <b-card v-if="userInfo" style="margin:1%">
        <b-row>
          <b-col md="1" xl="1" cols="0"/>
          <b-col md="10" xl="10" cols="12" align-self="center">
            <b-form-group label-align="right" :label="$t('Profile of documents')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listOfDocuments" v-model="userInfo.doc_profile_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Router')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select :options="listOfRouiers" v-model="userInfo.router_id"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Port')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="userInfo.port_number"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Currency')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="userInfo.binded_currency_id" :options="listOfCurrencies"/>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card>
    </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      listOfDocuments: [],
      listOfRouiers: [],
      listOfCurrencies: []
    }
  },
  methods: {
    async load () {
      let listOfDocuments = await axiosInstance.get(this.$store.getters.API_SETTINGS_DOCUMENTS_PROFILES).then(response => { return response.data })
      let listOfRouiers = await axiosInstance.get(this.$store.getters.API_SETTINGS_ROUTERS).then(response => { return response.data })
      this.listOfCurrencies = await axiosInstance.get(this.$store.getters.API_REFERENCE_BOOKS_CURRENCIES).then(response => { return response.data })
      for (let i in this.listOfCurrencies) {
        this.listOfCurrencies[i].value = this.listOfCurrencies[i].currency_id
        this.listOfCurrencies[i].text = this.listOfCurrencies[i].currency_brief_name
      }
      for (let i in listOfDocuments) {
        listOfDocuments[i].value = listOfDocuments[i].profile_id
        listOfDocuments[i].text = listOfDocuments[i].name
      }
      this.listOfDocuments = listOfDocuments
      for (let i in listOfRouiers) {
        listOfRouiers[i].value = listOfRouiers[i].id
        listOfRouiers[i].text = listOfRouiers[i].name
      }
      this.listOfRouiers = listOfRouiers
    }
  },
  watch: {
    currentRow: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/others/main.vue